import { render, staticRenderFns } from "./DiscussionRecordList.vue?vue&type=template&id=b416ad46&scoped=true&"
import script from "./DiscussionRecordList.vue?vue&type=script&lang=js&"
export * from "./DiscussionRecordList.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionRecordList.vue?vue&type=style&index=0&id=b416ad46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b416ad46",
  null
  
)

export default component.exports